import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "./portfolio/Nav";
import { Hero } from "./portfolio/Hero";
import { About } from "./portfolio/About";
import { Axes } from "./portfolio/Axes";
import { Skills } from "./portfolio/Skills";
import { Experience } from "./portfolio/Experience";
import { Formation } from "./portfolio/Formation";
import { Contact } from "./portfolio/Contact";
import { Footer } from "./portfolio/Footer";
import { ChatWidget } from "./portfolio/ChatWidget";

export default function Portfolio() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#05070A] text-white antialiased">
      <Nav />
      <main>
        <Hero />
        <About />
        <Axes />
        <Skills />
        <Experience />
        <Formation />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
